/* global Blockly */

import CoreResponse from '../../v1/assistingBlocks/CoreResponse';

// Auto-generated response value for APIs whose selected operation can return
// either text or a number.
const StringOrNumberResponse = function () {
    const name = 'string_or_number_response';

    Blockly.Blocks[name] = CoreResponse({
        shape: Blockly.OUTPUT_SHAPE_ROUND,
        type: ['String', 'Number']
    });

    Blockly.JavaScript[name] = function () {
        return [this.getJavascriptCore(), Blockly.JavaScript.ORDER_NONE];
    };
};

export default StringOrNumberResponse;
